export default {
    meta: {
        isShowHeader: false,
    },
};
